module.exports = __webpack_public_path__ + "static/img/escaparatismo.39ea54b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/obras_comerciales_secciones/escaparatismo.jpg
// module id = epA3
// module chunks = 1